import { FormArray, FormGroup } from '@angular/forms';
import { ContactChannelOptionType } from '@shared/utils/enums';
import { ChannelOptionsForm } from '@shared/utils/interfaces';

export const channelExists = (channels: FormArray<FormGroup<ChannelOptionsForm>>, type: ContactChannelOptionType): boolean => {
  return channels.controls.some((control) => control.controls.type.value === type);
};

export const availableChannelTypes = (
  channels: FormArray<FormGroup<ChannelOptionsForm>>,
  types: ContactChannelOptionType[],
): ContactChannelOptionType[] => {
  return types.filter((type) => !channelExists(channels, type));
};
